export enum ComponentTypes {
    SELECT = 'select',
    INPUT = 'input',
    STAT = 'stat',
    IMAGE = 'image',
    ICON = 'icon',
    TOGGLE = 'toggle'
}